
import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getGeneratedOrdersRequest, getGeneratedOrdersRequestError, getGeneratedOrdersRequestSuccess } from "../../slices/Supplier/GetGeneratedOrdersSlice";

export const GetGeneratedOrdersApi = (data) => async (dispatch) => {

    const queryParams = new URLSearchParams(data).toString();

    const urlWithParams = `${endpoints.getSupplierOrders}?${queryParams}`;

    try {
        dispatch(getGeneratedOrdersRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getGeneratedOrdersRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getGeneratedOrdersRequestError(_error));
            });
    } catch (error) {
    }
};
